import styled from 'styled-components/macro';

const StatusBlock = styled.span`
  display: inline-block;
  min-height: 32px;
  padding: 8px 5px 10px 0;

  &:not(:last-of-type)::after {
    content: ',';
  }
`;


export default StatusBlock;
